<!--suppress ALL -->
<template>
    <div class="carousel-custom"> {{img1}}
        <div class="row">
            <div class="caixa-img-principal col-xl-10 col-lg-9 col-md-12 col-sm-12 col-12 p-0 m-0" style="margin-right: 30px !important;">
                <!--Imagem Primária-->
                <img :style="{display: imagens[0].display}" class="img-principal" :src="imagens[0].url" alt="">
                <img :style="{display: imagens[0].display}" class="img-principal-blur" :src="imagens[0].url" alt="">
                <!--Imagem Secundária-->
                <img :style="{display: imagens[1].display}" class="img-principal" :src="imagens[1].url" alt="">
                <img :style="{display: imagens[1].display}" class="img-principal-blur" :src="imagens[1].url" alt="">
                <!--Imagem terciária-->
                <img :style="{display: imagens[2].display}" class="img-principal" :src="imagens[2].url" alt="">
                <img :style="{display: imagens[2].display}" class="img-principal-blur" :src="imagens[2].url" alt="">

                <img v-show="arrowLeft" @click="anteriorImg" class="arrow-left" src="../../assets/images/arrow_left.svg" alt="">
                <img v-show="arrowRight" @click="proximaImg" class="arrow-right" src="../../assets/images/arrow_right.svg" alt="">
            </div>
            <div class="col p-0 m-0 barra-lateral">
                <div class="row"><img :style="{opacity: imagens[0].opacity}" @click="trocarImg(0)" :src="imagens[0].url" class="img-mini mb-4 ativa" v-if="imagens[0].url" alt=""></div>
                <div class="row"><img :style="{opacity: imagens[1].opacity}" @click="trocarImg(1)" :src="imagens[1].url" class="img-mini mb-4" v-if="imagens[1].url" alt=""></div>
                <div class="row"><img :style="{opacity: imagens[2].opacity}" @click="trocarImg(2)" :src="imagens[2].url" class="img-mini" v-if="imagens[2].url" alt=""></div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'Carousel-custom',
    data() {
        return {
            imagemAtual: 0,
            load: true,
            imagens: [
                {url: '', opacity: 1.0, display: 'block'},
                {url: '', opacity: 0.7, display: 'none'},
                {url: '', opacity: 0.7, display: 'none'}
            ]
        }
    },
    async beforeCreate() {
        await this.$store.dispatch('getDadosAnuncio', {
            id: this.$route.query.id
        })
    },
    methods: {
        trocarImg (img) {
            if (img === this.imagemAtual) return false

            //oculta imagem anterior
            this.imagens[this.imagemAtual].display = "none"
            this.imagens[this.imagemAtual].opacity = 0.7
            //mostra próxima imagem
            this.imagemAtual = img
            this.imagens[this.imagemAtual].display = "block"
            this.imagens[this.imagemAtual].opacity = 1.0
        },
        proximaImg () {
            let proxImg = this.imagemAtual + 1
            if (proxImg === 3) proxImg = 0
            this.trocarImg(proxImg)
        },
        anteriorImg () {
            let proxImg = this.imagemAtual - 1
            if (proxImg === -1) proxImg = 2
            this.trocarImg(proxImg)
        },
        iniciarImgs () {
            if (!this.dadosAnuncio.imagem_primaria) return false
            this.imagens[0].url = this.dadosAnuncio.imagem_primaria
            this.imagens[1].url = this.dadosAnuncio.imagem_secundaria
            this.imagens[2].url = this.dadosAnuncio.imagem_terciaria
            this.$store.state.load = false
        }
    },
    computed: {
        ...mapState(['dadosAnuncio']),
        img1: function () {
            if (!this.dadosAnuncio.imagem_primaria) return ''
            this.iniciarImgs ()
            return ''
        },
        arrowLeft: function () {
            return this.imagemAtual !== 0
        },
        arrowRight: function () {
            let visible = true
            if (this.imagens[2].url !== undefined && this.imagemAtual === 2){
                visible = false
            } else if (this.imagens[2].url === undefined && this.imagemAtual === 1){
                visible = false
            } else if (this.imagens[1].url === undefined && this.imagemAtual === 0){
                visible = false
            }
            return visible
        }
    }
}
</script>
<style lang="scss" scoped>
@media (max-width: 992px) {
    .barra-lateral{
        display: none;
    }
}

@media (max-width: 576px) {
    .caixa-img-principal{
        height: 250px !important;

    }
    .img-principal{
        margin: 0 auto;
        height: 100%;
        //border-radius: 15px;
        z-index: 1;
    }
    .arrow-left{
        top: 108px !important;
        left: 20px;
    }
    .arrow-right{
        top: 108px !important;
        right: 20px;
    }
}
.caixa-img-principal{
    width: 100%;
    overflow: hidden;
    margin-bottom: 20px !important;
    height: 330px;
    display: flex;
    border-radius: 15px;
}
.img-principal{
    margin: 0 auto;
    height: 100%;
    z-index: 1;
}
.img-principal-blur{
    background-size: cover;
    background-attachment: fixed;
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    filter: blur(7px);
}

.arrow-left{
    position: absolute;
    top: 145px;
    left: 20px;
    z-index: 21;
    cursor: pointer;
}
.arrow-right{
    position: absolute;
    top: 145px;
    right: 20px;
    z-index: 21;
    cursor: pointer;
}

.carousel-custom{
    width: 100%;
}

.img-mini{
    width: 88px;
    height: 88px;
    object-fit: cover;
    border-radius: 15px;
    cursor: pointer;
}
.img-mini:hover{
    opacity: 1;
}
</style>
